<template>
  <div class="edit-owner-committee-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('editOwnerCommittee.title')" :subtitle="$t('editOwnerCommittee.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitForm">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 业委会信息表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('editOwnerCommittee.page.infoTitle') }}</span>
      </div>

      <el-form ref="form" :model="formData" label-width="120px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.name')" prop="name"
              :rules="[{ required: true, message: $t('editOwnerCommittee.nameRequired'), trigger: 'blur' }]">
              <el-input v-model.trim="formData.name" :placeholder="$t('editOwnerCommittee.namePlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.sex')" prop="sex"
              :rules="[{ required: true, message: $t('editOwnerCommittee.sexRequired'), trigger: 'change' }]">
              <el-select v-model="formData.sex" :placeholder="$t('editOwnerCommittee.sexPlaceholder')" class="w-full">
                <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.phone')" prop="link" :rules="[
              { required: true, message: $t('editOwnerCommittee.phoneRequired'), trigger: 'blur' },
              { min: 11, max: 11, message: $t('editOwnerCommittee.phoneLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.link" :placeholder="$t('editOwnerCommittee.phonePlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.idCard')" prop="idCard" :rules="[
              { required: true, message: $t('editOwnerCommittee.idCardRequired'), trigger: 'blur' },
              { min: 18, max: 18, message: $t('editOwnerCommittee.idCardLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.idCard" :placeholder="$t('editOwnerCommittee.idCardPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.address')" prop="address" :rules="[
              { required: true, message: $t('editOwnerCommittee.addressRequired'), trigger: 'blur' },
              { max: 256, message: $t('editOwnerCommittee.addressMaxLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.address" :placeholder="$t('editOwnerCommittee.addressPlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.position')" prop="position" :rules="[
              { required: true, message: $t('editOwnerCommittee.positionRequired'), trigger: 'blur' },
              { max: 64, message: $t('editOwnerCommittee.positionMaxLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.position" :placeholder="$t('editOwnerCommittee.positionPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.post')" prop="post" :rules="[
              { required: true, message: $t('editOwnerCommittee.postRequired'), trigger: 'blur' },
              { max: 64, message: $t('editOwnerCommittee.postMaxLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.post" :placeholder="$t('editOwnerCommittee.postPlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.postDesc')" prop="postDesc"
              :rules="[{ max: 64, message: $t('editOwnerCommittee.postDescMaxLength'), trigger: 'blur' }]">
              <el-input v-model.trim="formData.postDesc" :placeholder="$t('editOwnerCommittee.postDescPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.appointTime')" prop="appointTime" :rules="[
              { required: true, message: $t('editOwnerCommittee.appointTimeRequired'), trigger: 'blur' },
              { max: 256, message: $t('editOwnerCommittee.appointTimeMaxLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.appointTime" :placeholder="$t('editOwnerCommittee.appointTimePlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.curTime')" prop="curTime" :rules="[
              { required: true, message: $t('editOwnerCommittee.curTimeRequired'), trigger: 'blur' },
              { max: 256, message: $t('editOwnerCommittee.curTimeMaxLength'), trigger: 'blur' }
            ]">
              <el-input v-model.trim="formData.curTime" :placeholder="$t('editOwnerCommittee.curTimePlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.status')" prop="state"
              :rules="[{ required: true, message: $t('editOwnerCommittee.statusRequired'), trigger: 'change' }]">
              <el-select v-model="formData.state" :placeholder="$t('editOwnerCommittee.statusPlaceholder')" class="w-full">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editOwnerCommittee.remark')" prop="remark"
              :rules="[{ max: 200, message: $t('editOwnerCommittee.remarkMaxLength'), trigger: 'blur' }]">
              <el-input v-model.trim="formData.remark" type="textarea"
                :placeholder="$t('editOwnerCommittee.remarkPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- (3)(4) 紧急联系人面板 + 表格 -->
    <div class="ds-panel">
      <ds-toolbar :total="formData.contracts.length" :show-column-setting="false" :show-density="false"
        :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('editOwnerCommittee.emergencyContact') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addContract">
            {{ $t('common.add') }}
          </el-button>
        </template>
      </ds-toolbar>

      <ds-data-table :data="formData.contracts" density="default" border
        :empty-description="$t('editOwnerCommittee.page.empty')">
        <el-table-column :label="$t('editOwnerCommittee.relation')" align="center" min-width="130">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.relName" :placeholder="$t('editOwnerCommittee.relationPlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('editOwnerCommittee.contactName')" align="center" min-width="130">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.name" :placeholder="$t('editOwnerCommittee.contactNamePlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('editOwnerCommittee.contactPhone')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.link" :placeholder="$t('editOwnerCommittee.contactPhonePlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('editOwnerCommittee.contactAddress')" align="center" min-width="200">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.address" :placeholder="$t('editOwnerCommittee.contactAddressPlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteContract(scope.row)" />
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 表单操作区 -->
    <div class="ds-form-actions">
      <el-button icon="el-icon-back" @click="goBack">
        {{ $t('common.back') }}
      </el-button>
      <el-button type="primary" icon="el-icon-check" @click="submitForm">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getOwnerCommitteeDetail,
  updateOwnerCommittee,
  listOwnerCommitteeContract
} from '@/api/owner/editOwnerCommitteeApi'
//import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'EditOwnerCommittee',
  components: {
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      formData: {
        ocId: '',
        communityId: '',
        name: '',
        sex: '',
        link: '',
        idCard: '',
        address: '',
        position: '',
        post: '',
        postDesc: '',
        appointTime: '',
        curTime: '',
        state: '',
        remark: '',
        contracts: []
      },
      sexOptions: [
        { value: 'B', label: this.$t('editOwnerCommittee.male') },
        { value: 'G', label: this.$t('editOwnerCommittee.female') }
      ],
      statusOptions: [
        { value: '1000', label: this.$t('editOwnerCommittee.onDuty') },
        { value: '2000', label: this.$t('editOwnerCommittee.leave') }
      ]
    }
  },
  created() {
    this.formData.ocId = this.$route.query.ocId
    this.formData.communityId = getCommunityId()
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        // 获取业主委员会详情
        const detailRes = await getOwnerCommitteeDetail({
          ocId: this.formData.ocId,
          communityId: this.formData.communityId
        })
        Object.assign(this.formData, detailRes.data)

        // 获取紧急联系人列表
        const contractRes = await listOwnerCommitteeContract({
          ocId: this.formData.ocId,
          communityId: this.formData.communityId
        })
        this.formData.contracts = contractRes.data.map(item => ({
          ...item,
          id: item.contractId
        }))
      } catch (error) {
        this.$message.error(this.$t('editOwnerCommittee.fetchError'))
      }
    },
    addContract() {
      this.formData.contracts.push({
        id: Date.now().toString(),
        relName: '',
        name: '',
        link: '',
        address: ''
      })
    },
    deleteContract(contract) {
      const index = this.formData.contracts.findIndex(item => item.id === contract.id)
      if (index !== -1) {
        this.formData.contracts.splice(index, 1)
      }
    },
    async submitForm() {
      try {
        await this.$refs.form.validate()
        await updateOwnerCommittee(this.formData)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        if (error instanceof Error) {
          this.$message.error(error.message)
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-owner-committee-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
